var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
let windowLoaded = false;
if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
        windowLoaded = true;
    });
}
export const injectScript = (_a) => {
    var { src, async = true, defer = true, afterLoad = true } = _a, otherProps = __rest(_a, ["src", "async", "defer", "afterLoad"]);
    const inject = () => {
        // Create script element
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = async;
        script.defer = defer;
        script.src = src;
        Object.apply(script, otherProps);
        // Insert element
        document.head.appendChild(script);
        // Clean up event listener
        afterLoad && window.removeEventListener('load', inject);
    };
    if (afterLoad && !windowLoaded) {
        window.addEventListener('load', inject);
    }
    else {
        inject();
    }
};
//# sourceMappingURL=script.js.map